import { BaseController } from '../../../../../../../../common/base/controller';

export const ACCEPT_DEBITS_MODEL = {
  ACCEPT_DEBITS_CERTAIN_FULL_LIST: 'acceptDebitsCertainFullList',
  ACCEPT_DEBITS_CERTAIN: 'acceptDebitsCertain',
  ACCEPT_DEBITS_CERTAIN_SPECIAL_PAYMENT_PARTNER:
    'acceptDebitsCertainSpecialPaymentPartner',
};

export class ReceivingBankToDoController extends BaseController {
  constructor($scope, controllerService) {
    'ngInject';
    super({
      $scope,
      controllerService,
    });
  }

  get isAcceptDebitsCertain() {
    return (
      this.model.acceptDebitsCertain ===
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN
    );
  }

  get isAcceptDebitsCertainSpecialPaymentPartner() {
    return (
      this.model.acceptDebitsCertain ===
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN_SPECIAL_PAYMENT_PARTNER
    );
  }

  addAcceptDebitsCertainSpecialPaymentPartnerListMultiplier() {
    this.model.acceptDebitsCertainSpecialPaymentPartnerListMultiplier.push({
      acceptDebitsCertainSpecialPaymentPartnerList: '',
    });
  }

  removeAcceptDebitsCertainSpecialPaymentPartnerListMultiplier($index) {
    this.model.acceptDebitsCertainSpecialPaymentPartnerListMultiplier.splice(
      $index,
      1,
    );
  }

  $onInit() {
    this.dateOptions = {
      dateFormat: this.languageOptions.dateFormat,
      // accountswitch can not happen in the past
      minDate: new Date(),
    };

    this.acceptDebitspecialDateMessages = this.inputMessagesFor(
      'acceptDebitspecialDate',
    );

    this.acceptStandingOrderspecialDateMessages = this.inputMessagesFor(
      'acceptStandingOrderspecialDate',
    );

    this.acceptDebitsTypes = [
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN_FULL_LIST,
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN,
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN_SPECIAL_PAYMENT_PARTNER,
    ];
  }

  inputMessagesFor(field) {
    return {
      parse: 'receiving.createRequest.form.error.dateInvalid',
      required: `receiving.createRequest.form.error.required.${field}`,
      min: 'receiving.createRequest.form.error.minDate',
    };
  }
}
